// Lightweight publish-subscribe bus for workflow events fired by plugin items.
// Visor workflow dispatcher subscribes; item renders emit.
const _subscribers = [];

export function emitWorkflowEvent(event) {
  _subscribers.forEach((fn) => fn(event));
}

export function subscribeWorkflowBus(fn) {
  _subscribers.push(fn);
  return () => {
    const idx = _subscribers.indexOf(fn);
    if (idx > -1) _subscribers.splice(idx, 1);
  };
}

export function resetWorkflowBus() {
  _subscribers.length = 0;
}
